import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import DomainBreadcrumbs, { Crumb } from 'components/DomainBreadcrumbs';

type BreadcrumbItem = {
  label: string;
  path?: string;
};

type Props = {
  title: string;
  description: string;
  breadcrumbs?: BreadcrumbItem[];
  children: React.ReactNode;
};

/**
 * ガイドページ共通レイアウト
 * パンくず（共通 DomainBreadcrumbs）・タイトル・説明文・コンテンツエリアを提供する。
 */
const GuidePageLayout: React.FC<Props> = ({ title, description, breadcrumbs, children }) => {
  // 共通パンくずへ変換: 家アイコン › 利用ガイド › (中間) › 現在地
  const crumbs: Crumb[] = [
    { label: '利用ガイド', to: '/guide' },
    ...(breadcrumbs || []).map((b) => ({ label: b.label, to: b.path })),
    { label: title },
  ];

  return (
    <Stack spacing={2.5} sx={{ maxWidth: 960 }}>
      {/* パンくず（全ドメイン共通） */}
      <DomainBreadcrumbs items={crumbs} />

      {/* ヘッダー */}
      <Stack spacing={0.5}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>

      {/* コンテンツ */}
      {children}
    </Stack>
  );
};

export default GuidePageLayout;
